
import React from 'react';

const ExpertiseSection: React.FC = () => {
  const expertiseAreas = [
    {
      title: "Heavy Civil Construction",
      description: "Comprehensive coating inspection for bridges, highways, and major infrastructure projects",
      icon: "ri-building-line"
    },
    {
      title: "Industrial Facilities",
      description: "Specialized inspection services for manufacturing plants, refineries, and processing facilities",
      icon: "ri-factory-line"
    },
    {
      title: "Marine and Offshore Structures",
      description: "Expert coating inspection for marine environments and offshore installations",
      icon: "ri-ship-line"
    },
    {
      title: "Storage Tank Systems",
      description: "Professional inspection of storage tanks, containment systems, and pressure vessels",
      icon: "ri-oil-line"
    },
    {
      title: "Transportation Infrastructure",
      description: "Coating inspection for airports, rail systems, and transportation facilities",
      icon: "ri-train-line"
    },
    {
      title: "Power Generation Facilities",
      description: "Specialized inspection services for power plants and energy infrastructure",
      icon: "ri-flashlight-line"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            Industry Expertise and Specialization
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
            HP Inc Consulting Services delivers specialized coating inspection expertise across diverse industries and applications, ensuring optimal protection for critical infrastructure assets.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {expertiseAreas.map((area, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <i className={`${area.icon} text-blue-600 text-2xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {area.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
